import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils'

export const getBookingList = createAsyncThunk('booking/getBookingList',
  async (
    {
      typeMeta,
      statusMeta,
      venueMeta,
      searchMeta,
      startDateMeta,
      endDateMeta,
      subscriptionMeta,
      sortMeta,
      pageMeta,
      sizeMeta
    }: BookingListQuery) => {
      const url = `v1/bookings${serializeQueryParam(
        {
          venueId: venueMeta,
          type: typeMeta,
          status: statusMeta,
          search: searchMeta,
          startDate: startDateMeta,
          endDate: endDateMeta,
          subscriptionId: subscriptionMeta,
          sortBy: sortMeta,
          page: pageMeta, 
          size: sizeMeta
        })}`
      const response: AxiosResponse<BookingState> = await instance.get(url)
      return response.data
    })

export const createBooking = createAsyncThunk('booking/createBooking',
  async (data: BookingPayload) => {
    const response: AxiosResponse<BookingState> = await instance.post('v1/bookings', data)
    return response.data
  })

export const getBookingSummary = createAsyncThunk('booking/getBookingSummary',
  async (params: any) => {
    const paramText = new URLSearchParams(params)
    const url = `v1/bookings/type-summary?${paramText}`
    const response: AxiosResponse<BookingSummaryState> = await instance.get(url)
    return response.data
  })
